import React from "react";
import { Dialog, DialogButton, DialogContent, DialogFooter, DialogTitle } from "../../dialog";
import { Modal } from "../../modal";

export const UnsuportedBrowserDialog = ({
	title,
	message,
	goToOtherEditor,
	goBack,
	onGoToOtherEditor,
	onGoBack,
	...modalProps
}: {
	title: string;
	message: string;
	goToOtherEditor: string;
	goBack: string;
	onGoToOtherEditor?: () => void;
	onGoBack?: () => void;
}) => (
	<Modal isOpen {...modalProps}>
		<Dialog className="old-browser-dialog">
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>{message}</DialogContent>
			<DialogFooter>
				{goBack && onGoBack ? (
					<DialogButton type="button" onClick={onGoBack}>
						{goBack}
					</DialogButton>
				) : undefined}
				{goToOtherEditor && onGoToOtherEditor ? (
					<DialogButton type="button" onClick={onGoToOtherEditor}>
						{goToOtherEditor}
					</DialogButton>
				) : undefined}
			</DialogFooter>
		</Dialog>
	</Modal>
);
UnsuportedBrowserDialog.displayName = "UnsuportedBrowserDialog";
